// Desktop Buy Now
function buyNow(button) {
  const variantId = button.getAttribute('data-id');
  const innerBtn = button.children[0];

  innerBtn.classList.add('btn--loading');

  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(() => {
    window.location.href = '/checkout';
  })
  .catch(() => {
    innerBtn.classList.remove('btn--loading');
  });
}

// Mobile Buy Now
// function buyNowMobile(button) {
//   const variantId = button.getAttribute('data-id');
//   const innerBtn = button.children[0];

//   fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: variantId, quantity: 1 })
//   })
//   .then(() => {
//     window.location.href = '/checkout';
//   })
//   .catch(() => {
//     innerBtn.classList.remove('btn--loading');
//   });
// }


// Remove loading state after back navigation
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".btn--loading").forEach(btn => {
    btn.classList.remove("btn--loading");
  });
});

// Sync variant ID → Mobile Buy Now
document.addEventListener('DOMContentLoaded', () => {
  const variantSelect = document.querySelector('[name="id"]');
  const buyNowBtn = document.getElementById('buy-now-mobile');

  if (variantSelect && buyNowBtn) {
    buyNowBtn.setAttribute('data-id', variantSelect.value);

    variantSelect.addEventListener('change', () => {
      buyNowBtn.setAttribute('data-id', variantSelect.value);
    });
  }
});

// function buyNowMobile(button) {
//   // Always get selected variant ID
//   const variantInput = document.querySelector('[name="id"]');

//   if (!variantInput || !variantInput.value) {
//     console.error('Variant ID not found');
//     return;
//   }

//   const variantId = variantInput.value;
//   const innerBtn = button.querySelector('span');

//   innerBtn.classList.add('btn--loading');

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json'
//     },
//     body: JSON.stringify({
//       id: variantId,
//       quantity: 1
//     })
//   })
//   .then(res => res.json())
//   .then(data => {
//     if (data.status === 422) {
//       console.error(data);
//       innerBtn.classList.remove('btn--loading');
//       return;
//     }
//     // ✅ Go to cart after add
//     window.location.href = '/cart';
//   })
//   .catch(err => {
//     console.error(err);
//     innerBtn.classList.remove('btn--loading');
//   });
// }

function buyNowMobile(button) {
  // 🔥 Scope to current product container (quick view / PDP)
  const productContainer = button.closest('form, .product-section, .quick-add, .product');

  if (!productContainer) {
    console.error('Product container not found');
    return;
  }

  // ✅ Correct variant ID
  const variantInput = productContainer.querySelector('[name="id"]');

  if (!variantInput || !variantInput.value) {
    console.error('Variant ID not found');
    return;
  }

  const variantId = variantInput.value;

  // ✅ Correct quantity (fallback = 1)
  const qtyInput = productContainer.querySelector('[name="quantity"]');
  const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

  const innerBtn = button.querySelector('span');
  innerBtn.classList.add('btn--loading');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(res => res.json())
  .then(data => {
    if (data.status === 422) {
      console.error(data);
      innerBtn.classList.remove('btn--loading');
      return;
    }

    // ✅ Redirect to cart
    window.location.href = '/cart';
  })
  .catch(err => {
    console.error(err);
    innerBtn.classList.remove('btn--loading');
  });
}

// document.addEventListener('DOMContentLoaded', function () {

//   document.body.addEventListener('click', function (e) {
//     const btn = e.target.closest('.product-block .btn.btn--full.add-to-cart');
//     if (!btn) return;

//     e.preventDefault();
//     e.stopPropagation();

//     const gridItem = btn.closest('.grid-item');
//     if (!gridItem) return;

//     const quickAddBtn = gridItem.querySelector('.js-quick-add-btn');
//     if (!quickAddBtn) return;

//     // ✅ ADD LOADING
//     btn.classList.add('btn--loading');

//     // 🔥 TRIGGER QUICK ADD
//     ['mousedown', 'mouseup', 'click'].forEach(evt => {
//       quickAddBtn.dispatchEvent(
//         new MouseEvent(evt, {
//           bubbles: true,
//           cancelable: true,
//           view: window
//         })
//       );
//     });

//     // ✅ REMOVE LOADING (SAFE FALLBACK)
//     setTimeout(() => {
//       btn.classList.remove('btn--loading');
//     }, 2000);
//   });

// });

document.addEventListener('DOMContentLoaded', function () {

  document.body.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-block .btn.btn--full.add-to-cart');
    if (!btn) return;

    // ❌ PDP custom button ma JS apply na thavu joie
    if (btn.closest('.cst-pdp-btn')) return;

    e.preventDefault();
    e.stopPropagation();

    const gridItem = btn.closest('.grid-item');
    if (!gridItem) return;

    const quickAddBtn = gridItem.querySelector('.quick-add-btn');
    // const quickAddBtn = gridItem.querySelector('.js-quick-add-btn');
    if (!quickAddBtn) return;

    // ✅ ADD LOADING
    btn.classList.add('btn--loading');

    // 🔥 TRIGGER QUICK ADD
    ['mousedown', 'mouseup', 'click'].forEach(evt => {
      quickAddBtn.dispatchEvent(
        new MouseEvent(evt, {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );
    });

    // ✅ REMOVE LOADING (SAFE FALLBACK)
    setTimeout(() => {
      btn.classList.remove('btn--loading');
    }, 2000);
  });

});


$(document).ready(function(){
  $('#cust_act_mob').click(function(){
$('body').removeClass('commonpopup-open');
    $('.product-single__form button.add-to-cart').trigger('click');
});
  
  // if($('.rte.collection_footer_dis').height() >= 200){
  //   $(".cstm-text-link").show();
  // }else{
  //   $(".cstm-text-link").hide();
  // }
  // // collection page load more button

  // $(".cstm-text-link").click(function(){
  //   $(this).hide();
  //   $(".rte.collection_footer_dis").toggleClass("open");
  // });

  
// $('.home-collection-list-block').slick({
//   infinite: true,
//   arrows: false,
//    variableWidth: true,
//     slidesToScroll: 3

// });
  
   $('.product-single__form add-to-cart').click(function(e){
     e.preventDefault();
    console.log("test11");
});

  // product sticky hide

  $('.product-sticky .product-delivary.medium-up--hide .product-close').click(function(){
    $('.product-sticky-block .product-sticky-delivery').addClass('hide');
    $('body').removeClass("commonpopup-open");
  });
   $(".product-sticky-block .add-to-cart-wrapper").click(function (e){
     $('body').addClass("commonpopup-open");
   });
  
  // product home text column icon

  if($("body.template-product .home-text-column-with-image .grid__item").length < 3){
  $("body.template-product .home-text-column-with-image .grid.grid--uniform").addClass("home-lessicon");
  }

// recently viewed section slider 

  var isALARendered;
      function ALAcheck() {
       isALARendered = setInterval(function () {
       customALA()
       }, 2000);
      }
      ALAcheck();
      function customALA() {
      if($('.custom-recentlyviewd-slider-main .grid-item.grid-product').length >= 4) {
$(".custom-recentlyviewd-slider-main").addClass("this_slider");
       clearInterval(isALARendered); 
       // please enter slider code heare

      $('.custom-recentlyviewd-slider-main .new-grid.product-grid').flickity({
cellAlign: 'left',
pageDots: false,
wrapAround: false,
prevNextButtons: true,
contain: true
});
      } 
}  
 

// mobile qty change 
$(".js-qty__wrapper.mobile_qty_main_wrapper .js-qty__adjust").on("click", function(e) {
    e.preventDefault();
    var qty = parseInt($(this).closest(".js-qty__wrapper.mobile_qty_main_wrapper").find(".js-qty__num_mob").val());
    // console.log(qty);
    if ($(this).hasClass("js-qty__adjust--plus")){
      var max_qty = $(this).attr("data-max_qty");
  if (max_qty != undefined) {
      if(max_qty > qty){
        $(this).closest(".js-qty__wrapper.mobile_qty_main_wrapper").find(".js-qty__num_mob").val(qty + 1).change();
      }else{
         $("span.qty-note").empty().append(`You can not enter more than ${max_qty} quantity.`).show();
         $(this).css("pointer-events", "none");
      }
  }else{
    $(this).closest(".js-qty__wrapper.mobile_qty_main_wrapper").find(".js-qty__num_mob").val(qty + 1).change();
  }
    }else {
        var newQty = qty > 1 ? qty - 1 : 1;
        $(this).closest(".js-qty__wrapper.mobile_qty_main_wrapper").find(".js-qty__num_mob").val(newQty).change();
       $('.js-qty__adjust_mob').css("pointer-events", "");
    }
  $('.small--hide .js-qty__num.dis-product-qty').val($('.js-qty__num.js-qty__num_mob').val());
});

// popup 

$(".address-new-toggle.btn").click(function() {
$("body").addClass("commonpopup-open");
   $(".commom-popup.addaddress-popup .form-vertical").removeClass("hide");
  $(".commom-popup.addaddress-popup").show();
});
$(".commom-popup.addaddress-popup .commonpop-close").click(function() {
$("body").removeClass("commonpopup-open");
$(".commom-popup.addaddress-popup .form-vertical").addClass("hide");
   $(".commom-popup.addaddress-popup").hide();
});

  $(".address-edit-toggle.btn").click(function() {
$("body").addClass("commonpopup-open");
   $(".commom-popup.editaddress-popup .form-vertical").removeClass("hide");
  $(".commom-popup.editaddress-popup").show();
});
$(".commom-popup.editaddress-popup .commonpop-close").click(function() {
$("body").removeClass("commonpopup-open");
$(".commom-popup.editaddress-popup .form-vertical").addClass("hide");
   $(".commom-popup.editaddress-popup").hide();
});

  $(".account-checkbox.address-checkbox.customer-address-form-checkbox").click(function() {
    $("body").addClass("commonpopup-open");
    // $(".commom-popup.custom-choise-box").removeClass("hide");
    var popup_selectio = `.commom-popup.custom-choise-box${$(this).attr('data-form_id')}`;
    $(popup_selectio).removeClass("hide");
    var check_box = `${$(this).attr('data-form_id')}_setcust_form_id input[name="address[default]"]`;
    $(check_box).prop('checked', true);
    $(check_box).hide();
  });

    $(".enquiry-btn.btn").click(function() {
  // $("body").addClass("commonpopup-open");
  });

  if(window.location.search === "?contact_posted=true"){
    $("body.template-page").addClass("commonpopup-open")
  }

    $(".enquiry-form-section .commonpop-close").click(function() {
    $("body").removeClass("commonpopup-open");
    $(".enquiry-form-section .commom-popup").addClass("hide")
  });
  
  $(".commom-popup.custom-choise-box .commonpop-close").click(function() {
    $("body").removeClass("commonpopup-open");
    $(".commom-popup.custom-choise-box").addClass("hide");
  });

if ($(window).width() > 768) {

// feature-collection-list  
$('.feature-collection-list').each(function() {
if ($(this).find('.new-grid .grid-item').length > 3){
$(this).addClass("thisslider");
var feature_collections = $(this).find('.new-grid').flickity({
cellAlign: 'left',
pageDots: false,
wrapAround: false,
prevNextButtons: true, 
touchVerticalScroll: false,  
contain: true

});
}
else {
$(this).find('.new-grid').addClass("notslider");
}
});

// product tab scroll
$('.tabs #tabs-content').slimScroll({
  height: '272px',
  start: 'top',
  alwaysVisible: true
});

// Blog page
$( ".article-main.up-down-latestblog" ).wrapAll( "<div class='article-main-inner'></div>" );

}
else {
var feature_collections = $('.feature-collection-list .new-grid').flickity({
cellAlign: 'left',
pageDots: false,
prevNextButtons: false, 
touchVerticalScroll: false,  
wrapAround: true,
dragThreshold: 22
})

// product recently viewd product

setTimeout(function() {
var Recently_collection = $('.recently-viewed__section .new-grid').flickity({
cellAlign: 'left',
pageDots: false,
wrapAround: false,
prevNextButtons: false,
contain: true
});
}, 3500);

setTimeout(function() {
var Recommendations_collection = $('.product-reco .new-grid').flickity({
cellAlign: 'left',
pageDots: false,
wrapAround: false,
prevNextButtons: false,
contain: true
});
}, 3000);

// product tab scroll
$('.tabs #tabs-content').slimScroll({
height: '160px'
});

// collection list mobile slider
var custom_featured_collection = $('.custom-featured-collection.new-grid').flickity({
cellAlign: 'left',
pageDots: false,
wrapAround: false,
prevNextButtons: false,
contain: true
});


// diwali gift slider
// var custom_gift_diwali = $('.imagetext_gorup_slider').flickity({
// cellAlign: 'left',
// pageDots: false,
// wrapAround: false,
// prevNextButtons: false,
// contain: true
// });
  var custom_gift_diwali = $('.slider_active').flickity({
    cellAlign: 'left',
    pageDots: false,
    wrapAround: false,
    prevNextButtons: false,
    contain: true
  });
  
// account page

$(".template-customers-account .account-rightbar").addClass("hide");
$(".template-customers-account .account-main-header .title").removeClass("hide");
$(".template-customers-account .back-btn.other-back-btn").addClass("hide");
  
$(".template-customers-account .order-page-active").click(function(){
$(".template-customers-account .account-rightbar").removeClass("hide");
$(".template-customers-account .account-main-header .title").addClass("hide");
$(".template-customers-account .account-sidebar").addClass("hide");
$(".template-customers-account .back-btn.other-back-btn").removeClass("hide");
$(".template-customers-account .back-btn.accountpage").addClass("hide");
});
  
// filter upper 
$(".collection-filter" ).insertBefore( ".collection-header" );

// footer social
$(".footer__block[data-type='contact']").insertAfter( "footer .footer__blocks .footer__block[data-type=menu]:nth-child(2) .footer-menu-top" );

// recent blog post
var custom_recent_collection = $('.blog-layout__sidebar .articles-main-content').flickity({
cellAlign: 'left',
pageDots: false,
wrapAround: false,
prevNextButtons: false,
contain: true
});

// related blog post
var custom_related_collection = $('.related-blog-post .new-grid').flickity({
cellAlign: 'left',
pageDots: false,
wrapAround: false,
prevNextButtons: false,
contain: true
});

// about page
$(".about-content-block3").insertBefore( ".about-content-block2" );

// store page tab
$('.ourstore-tab-block ul').slick({
variableWidth: true,
cellAlign: 'left',
arrows: false,
slidesToScroll: 1,
infinite:false
});

// store page block

  $('.ourstore-right .content .store-location-block').each(function(i, obj) {
     console.log($(this).find('.store-location-content').length > 1);
    if ($(this).find('.store-location-content').length > 1){
      $(this).flickity({
          cellAlign: 'left',
          pageDots: false,
          wrapAround: false,
          prevNextButtons: false,
          contain: true
          });
    }
});
  
  
  
  
// var custom_related_collection = $('.ourstore-right .content .store-location-block').flickity({
// cellAlign: 'left',
// pageDots: false,
// wrapAround: false,
// prevNextButtons: false,
// contain: true
// });

};
  
// store page tab

// Show the first tab and hide the rest
$('.tabs-nav.col nav li:first-child').addClass('active');
$('.tabs-content .content').hide();
$('.tabs-content .content:first').show();

// Click function
$('.tabs-nav.col nav li').click(function(){
$('.tabs-nav.col nav li').removeClass('active');
$(this).addClass('active');
$('.tabs-content .content').hide();
$("#tabs-content").slimScroll({destroy: true});
  
var activeTab = $(this).find('a').attr('href');
$(activeTab).fadeIn();
  $('.tabs #tabs-content').slimScroll({
   height: '160px',
    });
return false;
});




$('.logo-list-section .new-grid.product-grid').slick({
  variableWidth: true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 6000,
  pauseOnHover: false,
  cssEase: 'linear',
  arrows: false
});


// feature collection section

// $('.home-collection-list-block').slick({
// slidesToShow: 5.19,
// slidesToScroll: 4,
// arrows: false,  
// infinite: false,
// contain: true,  
// autoplay: false  
// });

var video_slider = $('.video-slider-main .main-video-container').flickity({
pageDots: false,
prevNextButtons: true,
cellAlign: 'left',
speed: 6000,  
contain: true
});


// home video slider
$('.video-slider-main .main-video-container .thumble-play-wipper .play_video').click(function(){
// console.log($(this).attr('data-video_id'));
$('video').trigger('pause');
$('.video-slider-main .main-video-container .thumble-mian-content').show();
$('.video-slider-main .video-content .video-mian').hide();
$(this).parent('.thumble-play-wipper').parent('.thumble-mian-content').hide();
$(this).parent('.thumble-play-wipper').parent('.thumble-mian-content').parent('.video-content').find('.video-mian').show();
$($(this).attr('data-video_id'))[0].play();
});

  $('.video-slider-main .main-video-container .thumble-pause-wipper .pause_video').click(function(){

    $('video').trigger('pause');
    $('.video-slider-main .main-video-container .thumble-mian-content').show();
    $('.video-slider-main .video-content .video-mian').hide();
    
  });
  
// menu

$('.slide-nav__wrapper .slide-nav__button.step2').click(function(){
$(this).next('ul.slide-nav__dropdown').slideToggle();
$(this).next('ul.slide-nav__dropdown').toggleClass('activemenu');
$(this).toggleClass("dropdownactive");
});

$('.slide-nav__wrapper .slide-nav__button.step1').click(function(){
$(this).next('ul.slide-nav__dropdown').slideToggle();
$(this).next('ul.slide-nav__dropdown').toggleClass('activemenu');
$(this).toggleClass("dropdownactive");
});

});

// blog page 

$(".template-article .blog-layout__main , .blog-layout__sidebar").wrapAll("<div class='blog-layout-main-block'></div>")

$(document).on("click", ".collection-filter__sort", function(t) {
$(this).toggleClass("active");
$('.collection-filter__sort ul').toggleClass("hide");
});


// cartpage 


$(document).on("click", ".cart-date-picker-toggel", function(t) {
  console.log($('.date-picker-list>li').length > 0);
if ($('.date-picker-list>li').length > 0){
    $('#cart-date-picker').toggle();
}
});


$(document).on("click", "body", function(t) {
// console.log(t.target);
if($(t.target).is('.collection-filter__btn, .collapsible-trigger__layout, .CollectionSidebar-1, .collapsible-content__inner, .collapsible-trigger__layout>span, .collection-filter__sort, .sort-part, .sort-part>label ')){
 }else{
  $('.collection-filter__sort').removeClass("active");
  $('.collection-filter__sort ul').addClass("hide");
 $('.collection-filter__btn.is-active').click();
}
if($(t.target).is('#cart-date-picker, #cart-date-picker>li, .cart-date-picker-toggel')){
 }else{
  $('#cart-date-picker').hide();
}


});

$('.collection-filter__btn').click(function(){

$('.collection-filter__sort').removeClass("active");
$('.collection-filter__sort ul').addClass("hide");
});

$('.sort-part, .collection-filter__sort, .sort-part>label ').click(function(){
$('.collection-filter__btn.is-active').click();
});


$(window).on("load",function(){
var windowheight= $(window).height() - 86;
console.log($(window).height());
$(".scroll-nav").css("max-height",windowheight);

});

// if ($(window).width() < 769) {
// $(window).on("load",function(){
// var max_height_wrap_slider = $('.index-section--hero .hero__image-wrapper').height()+$('.index-section--hero .hero__text-wrap').height();
// $(".hero-slideshow-wrapper").css("padding-bottom",max_height_wrap_slider);
// });
// }


(function ($) {
  function updateHeroSliderHeight() {
    if (window.innerWidth >= 769) return;

    $('.index-section--hero .hero-slideshow-wrapper').each(function () {
      var $slider = $(this);
      var $slide = $slider.find('.is-selected .hero__image-wrapper').first();
      var $text = $slider.find('.is-selected .hero__text-wrap').first();

      // Fallback before Flickity has selected a slide
      if (!$slide.length) {
        $slide = $slider.find('.hero__image-wrapper').first();
        $text = $slider.find('.hero__text-wrap').first();
      }

      if (!$slide.length || !$text.length) return;

      var imageHeight = $slide.outerHeight();
      var textHeight = $text.outerHeight(true);
      var totalHeight = imageHeight + textHeight;

      if (totalHeight > 0) {
        $slider.css('padding-bottom', totalHeight + 'px');
      }
    });
  }

  // Calculate as soon as possible and recalculate after images load
  $(document).ready(updateHeroSliderHeight);
  $(window).on('load resize', updateHeroSliderHeight);

  // Recalculate after Flickity changes slides
  $(document).on('change.flickity', '.hero-slideshow-wrapper', function () {
    requestAnimationFrame(updateHeroSliderHeight);
  });
})(jQuery);


// // Show the first tab and hide the rest
// $('.tabs-nav li:first-child').addClass('active');
// $('.tab-content').hide();
// $('.tab-content:first').show();

// // Click function
// $('.tabs-nav li').click(function(){
// $('.tabs-nav li').removeClass('active');
// $(this).addClass('active');
// $('.tab-content').hide();
// $(".tabs-content").slimScroll({destroy: true});
  
// var activeTab = $(this).find('a').attr('href');
// $(activeTab).fadeIn();
//    $('.tabs .tabs-content').slimScroll({
//     height: '272px',
//     start: 'top',
//     alwaysVisible: true
//   });
// return false;
// });
// Event delegation for dynamic popup content

$(document).on('click', '.tabs-nav li', function (e) {
  e.preventDefault();

  var $tabs = $(this).closest('.tabs');

  // Active tab
  $tabs.find('.tabs-nav li').removeClass('active');
  $(this).addClass('active');

  // Hide all tab content
  $tabs.find('.tab-content').hide();

  // Reset slimScroll
  $tabs.find('.tabs-content').slimScroll({ destroy: true });

  // Show selected tab
  var activeTab = $(this).find('a').attr('href');
  $tabs.find(activeTab).fadeIn();

  // Init slimScroll
  $tabs.find('.tabs-content').slimScroll({
    height: '272px',
    start: 'top',
    alwaysVisible: true
  });
});

  $('.tabs').each(function () {
    var $firstTab = $(this).find('.tabs-nav li:first');

    if ($firstTab.length && !$firstTab.hasClass('active')) {
      $firstTab.trigger('click');
    }
  });

$('.cart-note-wrapper .add-note').click(function(){

$('.custom-message-popup').addClass("active");
$('.message-popup-overlay').addClass("active");
});

$('.custom-message-popup .close-icon,.custom-message-popup .message-footer-btn,.message-popup-overlay').click(function(){
  $('.custom-message-popup').removeClass("active");
  $('.message-popup-overlay').removeClass("active");
});

$( document ).ready(function() {
  $carousel.on( 'dragStart.flickity', function( event, pointer ) {
      document.ontouchmove = function (e) {
          e.preventDefault();
      }
  });
  $carousel.on( 'dragEnd.flickity', function( event, pointer ) {
      document.ontouchmove = function (e) {
          return true;
      }
  });
});  

jQuery.fn.equalheight = function(_selector){
    
    var desNewHeight = 0; //for the description section
    var headerNewHeight = 0; //for the description section

    //Calculating the header new height
    jQuery(".button-text-boxes").each(function () {
        if (headerNewHeight < jQuery(this).outerHeight()) {
            headerNewHeight = jQuery(this).outerHeight();
        }
    });
    //Set the header new height
    jQuery(".button-text-boxes").css("min-height", headerNewHeight);
    return true;
}

  
                    